import { legislativeItemLink, meetingBodyLink } from './links.js';
import { meetingJoinDimensions, meetingJoinTimeDimensions } from './shared-dimensions.js';
import { voteOutcomeValueLabels, voteTypeValueLabels } from './value-labels.js';
/**
 * Combination data source: Motion Votes x Members x Meetings.
 * One row per member vote on a motion, with the mover, seconder, and computed outcome.
 */
export const voteRecordsCube = {
    category: 'Meetings',
    description: 'Every recorded vote by member with the motion, mover, seconder, and computed outcome.',
    label: 'Vote Records',
    question: 'How did each member vote on each motion?',
    bestFor: 'Roll call vote detail per item: each member’s aye, nay, abstain, recuse, or absent, plus the mover, seconder, and whether the motion passed.',
    tags: ['Votes', 'Minutes', 'Members'],
    requiredModule: 'hasRecord',
    measures: {
        'vote_records.count': { label: 'Count', type: 'number' },
        'vote_records.aye_votes': { label: 'Ayes', type: 'number' },
        'vote_records.nay_votes': { label: 'Nays', type: 'number' },
        'vote_records.abstain_votes': { label: 'Abstentions', type: 'number' },
        'vote_records.recuse_votes': { label: 'Recusals', type: 'number' },
        'vote_records.absent_votes': { label: 'Absences', type: 'number' },
    },
    dimensions: {
        // Vote
        'vote_records.vote': { label: 'Vote', type: 'string', valueLabels: voteTypeValueLabels },
        // Member
        'meeting_members.first_name': { label: 'Member First Name', type: 'string' },
        'meeting_members.last_name': { label: 'Member Last Name', type: 'string' },
        // Motion
        'minutes_motions.action_name': { label: 'Action', type: 'string' },
        'minutes_motions.motion_text': { label: 'Motion Text', narrative: true, type: 'string' },
        'minutes_motions.mover_name': { label: 'Mover', type: 'string' },
        'minutes_motions.seconder_name': { label: 'Seconder', type: 'string' },
        'minutes_motions.aye_count': { label: 'Aye Count', type: 'number' },
        'minutes_motions.nay_count': { label: 'Nay Count', type: 'number' },
        'minutes_motions.outcome': {
            label: 'Outcome',
            type: 'string',
            valueLabels: voteOutcomeValueLabels,
        },
        // Legislative Item
        'legislative_items.code': { label: 'Item Number', link: legislativeItemLink, type: 'string' },
        'legislative_items.full_title': {
            label: 'Item Title',
            link: legislativeItemLink,
            type: 'string',
        },
        // Meeting
        ...meetingJoinDimensions,
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    },
    timeDimensions: {
        ...meetingJoinTimeDimensions,
        'minutes_motions.vote_recorded_at': { label: 'Vote Recorded At', type: 'date' },
    },
};
